import { NavLink } from "react-router-dom"
import { useState } from "react"
import '../../styles/ui/nav.scss'
import useWindowDimensions from "../utility/DimensionTracker"
const Nav = () => {

    const [isOpen, setOpen] = useState(false)
    const { height, width } = useWindowDimensions();

    return (
        <nav
            className={`nav-container ${width <= 1000 && "mobile"}`}
        >
            {
                width <= 1000 &&
                <div className='button-wrapper' aria-label="Menu Button">
                    <div className={`${isOpen ? ' button menu-button-open' : 'button menu-button-close'}`}
                        onClick={()=>{
                            setOpen(!isOpen)
                        }}
                    >
                        <div className="hamburger-line-1"></div>
                        <div className="hamburger-line-2"></div>
                        <div className="hamburger-line-3"></div>
                    </div>
                </div>
            }
            <div className={width <= 1000 ? 'nav-list-mobile' : 'nav-list'}>
                <div className={`${width <= 1000 ? isOpen ? 'open-nav' : 'closed-nav' : 'regular-nav'}`}>
                    <NavLink to="/" className={({isActive})=>isActive ? 'active-link' : 'inactive' }

                        onClick={()=>{
                            setOpen(false)
                        }}
                    >
                        Top
                    </NavLink>
                    <NavLink to="/story" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                        onClick={()=>{
                            setOpen(false)
                        }}
                    >
                        Story
                    </NavLink>
                    <NavLink to="/character" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                        onClick={()=>{
                            setOpen(false)
                        }}
                    >
                        Characters
                    </NavLink>
                    <NavLink to="/field-notes" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                        onClick={()=>{
                            setOpen(false)
                        }}
                    >
                        Field Notes
                    </NavLink>
                    <NavLink to="/world" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                        onClick={()=>{
                            setOpen(false)
                        }}
                    >
                        World
                    </NavLink>
                    <NavLink to="/system" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                        onClick={()=>{
                            setOpen(false)
                        }}
                    >
                        System
                    </NavLink>
                    <NavLink to="/products" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                        onClick={()=>{
                            setOpen(false)
                        }}
                    >
                        Products
                    </NavLink>
                    <NavLink to="/gallery" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                        onClick={()=>{
                            setOpen(false)
                        }}
                    >
                        Gallery
                    </NavLink>
                   
                    <NavLink to="/fanart" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                        onClick={()=>{
                            setOpen(false)
                        }}
                    >
                        FAN ART
                    </NavLink>
                </div>
            </div>
        </nav>
    )
}

export default Nav;